const baseStyle = {
  fontWeight: 400,
  lineHeight: '125%',
}

const defaultProps = {
  size: 'md',
}

const parts = ['button', 'item', 'list']

const sizes = {
  sm: {
    button: {
      size: 'sm',
    },
    list: {
      size: 'sm',
    },
  },
  md: {
    button: {
      size: 'md',
    },
    list: {
      size: 'md',
    },
  },
  lg: {
    button: {
      size: 'lg',
    },
    list: {
      size: 'lg',
    },
  },
}

const variants = {}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
